export const GOOGLE_MAPS_BASE_URL =
  'https://www.google.com/maps/search/Asurion+';

export const getGoogleMapUrl = (urlParam?: string) => {
  return urlParam ? GOOGLE_MAPS_BASE_URL + urlParam : GOOGLE_MAPS_BASE_URL;
};
